import { createContext, useContext } from 'react';
import { assert } from 'ts-essentials';

import type { IsElementHidden, RegisterElement } from './types';

export interface DynamicOverflowContextData<T> {
  registerElement: RegisterElement<T>;
  isElementHidden: IsElementHidden;
  refresh: () => void;
}

export const DynamicOverflowContext = createContext<DynamicOverflowContextData<unknown> | null>(
  null,
);

export const useDynamicOverflowContext = <T,>() => {
  const values = useContext(DynamicOverflowContext);

  assert(values, '`useDynamicOverflowContext` must be used inside of a `DynamicOverflow`.');

  return values as DynamicOverflowContextData<T>;
};
